var _rect, _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.852905,
    y: 0.536255,
    width: 45.0735,
    height: 45.0735,
    rx: 22.5368,
    fill: "white",
    fillOpacity: 0.2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.9171 23.0303C33.9171 23.6905 33.3669 24.204 32.7433 24.204H31.5695L31.6062 30.073C31.6062 30.183 31.6062 30.2931 31.6062 30.3664V30.9533C31.6062 31.797 30.9459 32.4206 30.1389 32.4206H29.552C29.4787 32.4206 29.442 32.4206 29.4053 32.4206C29.3686 32.4206 29.2953 32.4206 29.2586 32.4206H27.2045C26.3608 32.4206 25.7372 31.797 25.7372 30.9533V27.7254C25.7372 27.1018 25.187 26.5516 24.5634 26.5516H22.2159C21.5556 26.5516 21.0421 27.1018 21.0421 27.7254V30.9533C21.0421 31.797 20.3818 32.4206 19.5748 32.4206H17.5207C17.4473 32.4206 17.4107 32.4206 17.3373 32.4206C17.3006 32.4206 17.2639 32.4206 17.2273 32.4206H16.6404C15.7967 32.4206 15.1731 31.797 15.1731 30.9533V26.8451C15.1731 26.8451 15.1731 26.8084 15.1731 26.7717V24.204H13.9993C13.3391 24.204 12.8255 23.6905 12.8255 23.0303C12.8255 22.7001 12.9356 22.4067 13.1923 22.1499L22.5827 13.9701C22.8394 13.7133 23.1329 13.6399 23.3896 13.6399C23.6464 13.6399 23.9399 13.75 24.1599 13.9334L33.5136 22.1499C33.807 22.4067 33.9538 22.7001 33.9171 23.0303Z",
    fill: "url(#paint0_linear_1064_8150)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1064_8150",
    x1: 19.5717,
    y1: 31.073,
    x2: 29.8241,
    y2: 16.9759,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#622FF5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#44A0F8"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.68737ac25a8679b033b34355db7df1be.svg";
export { ForwardRef as ReactComponent };